<template>
    <a :href="l.say(props.link)" :class="[override_class_native, l.say(props.class)]" :target="props.target" @click=onClick>
        <i v-if="props.icon" :class='props.icon' aria-hidden="true"></i>
        <span v-if="props.text" v-html="l.say(props.text)"></span>
    </a>
</template>

<script setup>
  import { defineProps }  from "vue";
  import Language         from '@/js/Shared/Language/Language.js'
  import ClientLoggingControllerSingleton from "@/js/Webmail/ClientLogging/ClientLoggingController";
  import GTMAnalyticsControllerSingleton from "@/js/Webmail/Analytics/GTMAnalyticsController";


  const l     = Language;
  const props = defineProps({
    text : {
      type    : String,
      default : null,
    },

    class: {
      type    : String,
      default : null,
    },

    override_class_native: {
      type    : String,
      default : 'button',
    },

    icon: {
      type    : String,
      default : null
    },

    link : {
      required : true,
    },

    target : {
      type    : String,
      default : '_self',
    },

    gtm : {
      default : null,
    }
  })

  const onClick = (event) => {
    ClientLoggingControllerSingleton.addEntry({
      type: 'link-button-click',
      text: props.text || event.currentTarget.getAttribute('data-text') || 'no-text',
    });


    if (props.gtm) {
      GTMAnalyticsControllerSingleton.postTrackerLink(
        props.gtm.module,
        props.gtm.feature,
        props.gtm.block,
        props.gtm.action
      );
    }
  }

</script>